import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { GlobalContext } from '../../reducer/context'
import LoginPage from '../pages/login/LoginPage';

const LoginPageWrapper = () => {
    const { authState } = useContext(GlobalContext);

    return (
        <div>
            {!authState.isAuthenticated ? <LoginPage /> : <Outlet />}
        </div>
    )
}

export default LoginPageWrapper